import {
  getFirestore,
  collection,
  doc,
  deleteDoc,
  setDoc,
  addDoc,
  orderBy,
  query,
  onSnapshot,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Agregamos esta línea
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDAL0mGTNcuht7uPwETKg_Jip-xEoOB6pk",
  authDomain: "e-compliance.firebaseapp.com",
  projectId: "e-compliance",
  storageBucket: "e-compliance.appspot.com",
  messagingSenderId: "306843772246",
  appId: "1:306843772246:web:a4ceff15233a04152122f7",
  measurementId: "G-03FSCT2R0Y",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app); // Agregamos esta línea

export {
  db,
  collection,
  doc,
  deleteDoc,
  setDoc,
  addDoc,
  orderBy,
  query,
  onSnapshot,
  getStorage,
  auth, // Agregamos esta línea
};
